import {MenuItem, SelectField} from 'material-ui';
import FlatButton from 'material-ui/FlatButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

import { HeadlineH1 } from '../arkulpa-fec/components/Text';
import { Label } from '../arkulpa-fec/components/FormElements';
import { convertErrors } from '../arkulpa-fec/utils/errorHelper';
import {getSnippetDefinition, getSnippetTypes} from '../snippetDefinitions';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';
import ArkEdit from '../arkulpa-fec/components/ArkEdit';
import ContentBuilder from '../arkulpa-fec/components/Content/ContentBuilder';
import ErrorMessage from '../arkulpa-fec/components/ErrorMessage';
import LoadingIndicator from '../arkulpa-fec/components/LoadingIndicator';
import config from '../config';
import filterOutNotDefinedValues from
  '../arkulpa-fec/utils/filterOutNotDefinedValues';

const ColoredSection = styled.section`
  background: #efefef;
  margin: 40px -40px;
  padding: 30px 40px;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    let {snippet} = props.snippetQuery || {};
    this.state = {
      project: config.getProjectKey(),
      type: 'text',
      title: '',
      slug: '',
      description: '',
      snippet: {},
      ...filterOutNotDefinedValues(snippet),
    };
  }

  componentWillReceiveProps = newProps => {
    let {error, snippet} = newProps.snippetQuery || {};

    if (error) {
      const {graphQLErrors} = error || {};
      this.setState({errors: graphQLErrors});
    } else {
      this.setState({errors: [], ...filterOutNotDefinedValues(snippet)});
    }
  };

  _goBackToList = () => this.props.history.goBack();

  _renderHeadline = () => {
    if (this._isNew()) {
      return <HeadlineH1>New content</HeadlineH1>;
    }
    return <HeadlineH1>Edit content</HeadlineH1>;
  };

  _isNew = () => !this.props.match.params.id;


  _changeSnippet = (key, value) => {
    const {snippet} = this.state;

    this.setState({snippet: {...snippet, [key]: value}});
  };

  handleSnippetTypeChange = (event, index, value) => {
    this.setState({
      type: value,
    });
  };

  _save = () => {
    const {...state} = filterOutNotDefinedValues(this.state);
    this.props
      .save({
        ...state,
      })
      .then(() => this._goBackToList())
      .catch(rawErrors => {
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
  };

  _renderSnippetType = () => {
    const snippetTypes = getSnippetTypes();
    if (!snippetTypes.length) {
      return <div>!!Snippet Types not defined!!</div>;
    }
    return (
      <SelectField floatingLabelText="Snippet Type" value={this.state.type} onChange={this.handleSnippetTypeChange}>
        {snippetTypes.map(type => <MenuItem key={type} value={type} primaryText={type} />)}
      </SelectField>
    );
  };

  render() {
    let {project, type, title, slug, snippet, description} = this.state;
    if (this.props.snippetQuery && this.props.snippetQuery.loading) {
      return <LoadingIndicator />;
    }
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        {this._renderHeadline()}
        {this._renderSnippetType()}
        <ColoredSection>
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="Title*"
            value={title}
            onChange={({target: {value}}) => this.setState({title: value})}
          />
          <TextField
            type="text"
            fullWidth={true}
            floatingLabelText="slug"
            value={slug}
            onChange={({target: {value}}) => this.setState({slug: value})}
          />

          <Label>Description</Label>
          <ArkEdit value={description} onChange={value => this.setState({description: value})} />
        </ColoredSection>
        <ContentBuilder
          contentDefinition={getSnippetDefinition(project, type)}
          values={snippet}
          changeValue={this._changeSnippet}
          config={config}
          inlineMode={true}
        />

        <ActionButtonRow>
          <FlatButton onClick={this._goBackToList} label="Zurück zur Übersicht" />
          <div>
            {/*{!this.isNew() && <FlatButton onClick={() => this.setState({deleteModalOpen: true})} label="löschen" />}*/}

            <FlatButton primary onClick={this._save} label="speichern" />
          </div>
        </ActionButtonRow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SnippetForm.js